import { memo } from "react";
import PropTypes from "prop-types";
import { useDarkModeData } from "src/context/DarkModeContext";

export function LogoIcon(props) {
  const { darkMode } = useDarkModeData();
  const asiakasId = props.asiakasId;
  const path = "/img/logoIcons/";

  const childProps = { ...props };
  delete childProps.asiakasId;
  const inversePercent = darkMode === true ? "80%" : "20%";

  const styles = {
    logoIcon: {
      maxHeight: "50px",
      maxWidth: "50px",
      filter: "invert(" + inversePercent + ")",
    },
  };

  const imgFile = path + asiakasId + ".png";
  if (asiakasId === 8) return <img src={imgFile} style={styles.logoIcon} {...childProps} />;
  return <></>;
}

LogoIcon.propTypes = {
  asiakasId: PropTypes.number,
};

export default memo(LogoIcon);
